module.exports = __webpack_public_path__ + "img/5.e9a475eb.jpg";